<template>
    <el-form ref="claim" label-width="120px" :label-position="labelPosition" size="small">

        <el-tabs v-model="activeName" plane>
            <el-tab-pane :label="$t('Məlumat')" name="claim">
                <div class="d-flex justify-content-center" style="padding-bottom: 10px"></div>

                <card>
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <el-table :default-expand-all="true" :data="item.filter(
                                    (data) =>
                                        !search ||
                                        data.claimNumber
                                            .toString()
                                            .toLowerCase()
                                            .includes(search.toString().toLowerCase())
                                )
                                    " style="width: 100%">
                                    >
                                    <el-table-column type="expand">
                                        <template slot-scope="scope">
                                            <div class="row" style="margin-left: 30px">
                                                <div class="col-11">
                                                    <assessments :readonly="true" @refresh="getData" :claimId="Number(scope.row.claimId)" />

                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>


                                    <el-table-column :label="$t('İş_№')" width="120" prop="dispClaimNumber">
                                    </el-table-column>

                                    <el-table-column :label="$t('DQN')" width="100" prop="regNumber">
                                    </el-table-column>

                                    <el-table-column label="Zəng olunacaq şəxs" width="350" prop="phone">
                                        <template slot-scope="scope">
                                            <div>
                                                <span>S.A.A: {{ scope.row.clientFullName }}</span>
                                                <br>
                                                <span>Nömrə: {{ scope.row.clientPhone }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>


                                    <el-table-column :label="$t('Qiymətləndirici')" prop="techExpertUserName">
                                    </el-table-column>

                                    <el-table-column :label="$t('İcraçı')" prop="clientServiceUserName">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>

                </card>

            </el-tab-pane>

            <el-tab-pane name="aprrove" label="Təsdiqlənmə">
                <card v-if="this.claimStatus >= 150">
                    <div>
                        <div class="row">
                            <div class="col-10">
                                <el-button size="small" type="warning" v-if="this.claimStatus <= 150"><i class="fa-solid fa-play"></i>
                                    Təsdiqlənməyə göndər</el-button>
                                <div v-else>
                                    <i class="fa-solid fa-check"></i>
                                    &nbsp;
                                    <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
                                        "Təsdiqlənməyə göndərilmişdir " +
                                        act.createdBy
                                    }}</span><br />
                                </div>

                            </div>
                        </div>
                        <br>
                        <signers v-if="item.id" :value="item.id"></signers>
                    </div>

                </card>
            </el-tab-pane>
            <el-tab-pane name="payment" label="Ödəniş">
                <card>
                    <div>

                    </div>
                </card>
            </el-tab-pane>
        </el-tabs>
    </el-form>
</template>
  
<script>
import Assessments from "../components/Assessments.vue";
import { GetClaimApprasial, LastClaimStatus, GetClaimAct } from "src/services/claim";
import Signers from "../components/Signers.vue";
import { labelPosition } from "../../services/helper";

export default {
    props: {
        id: [String, Number],
    },
    components: {
        Assessments,
        Signers
    },
    data() {
        return {
            activeName: "claim",
            claimId: this.id,
            uid: this.$store.state.user.id,
            item: [],
            search: null,
            claimStatus: {},
            act: [],
            labelPosition: labelPosition,
        };

    },
    methods: {
        async getData() {
            try {
                const response = await GetClaimApprasial(this.id);
                if (response.data.data) {
                    this.item = response.data.data;
                    this.getClaimAct();
                    await this.lastClaimStatus();
                } else {
                    this.$message({
                        type: "warning",
                        message: "Səhv əməliyyat",
                    });
                }
            } catch (error) {
                this.loading = false;
                this.$message({
                    type: "error",
                    message: "Bir səhv baş verdi",
                });
            }
        },
        async lastClaimStatus() {
            try {
                const response = await LastClaimStatus(this.item[0].claimId);
                if (response) {
                    this.claimStatus = response.data.data;
                } else {
                    this.$message({
                        type: "warning",
                        message: "Səhv əməliyyat",
                    });
                }
            } catch (error) {
                this.$message({
                    type: "error",
                    message: "Bir səhv baş verdi",
                });
            }
        },
        getClaimAct() {
            GetClaimAct(this.item[0].claimId).then((response) => {
                if (response.data.data) {
                    this.act = response.data.data;
                }
            });
        },
    },
    mounted() {
        this.getData();
    },

};
</script>
  
<style lang="scss" scoped></style>